import { Component, OnInit, OnDestroy, Input } from '@angular/core'
import { ChannelLogoWidget } from 'htv-lib'
import { Subscription } from 'rxjs'
import { DynamicImageComponent } from '../dynamic-image/dynamic-image.component'
import { LocalChannel } from '../../interfaces/local-channel'
import { PageService } from '../../services/page.service'
import { PAGE_KEY } from '../../constants/page.constants'

@Component({
  selector: 'app-channel-logo',
  standalone: true,
  imports: [DynamicImageComponent],
  templateUrl: './channel-logo.component.html',
  styleUrls: [],
})
export class ChannelLogoComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription()
  @Input() config!: ChannelLogoWidget

  url = ''

  constructor(private pageService: PageService) {
    // do nothing
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.pageService.getSubject(PAGE_KEY.SELECTED_CHANNEL)?.subscribe((channel: LocalChannel | undefined) => {
        if (channel) {
          this.url = channel.logoUrl
        } else {
          this.url = ''
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }
}
